import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SocketService from "../Service/SocketService";
import { toast } from "react-toastify";

export default function FairWarning() {
    const { isConnected } = useSelector((state) => state.socket);
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const stages = ["Going Thrice", "Going Twice", "Going Once"];

    const [stageIndex, setStageIndex] = useState(0);
    const [countdown, setCountdown] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [duration, setDuration] = useState(0);
    const [showFairWarning, setShowFairWarning] = useState(false);

    useEffect(() => {
        if (!isRunning) return;

        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [isRunning]);

    useEffect(() => {
        if (!isRunning) return;

        if (countdown === 0) {
            if (stageIndex < stages.length - 1) {
                setStageIndex((prev) => prev + 1);
                setCountdown(duration);
            } else {
                setIsRunning(false);
                setShowFairWarning(false);
            }
        }
    }, [countdown, isRunning, stageIndex]);

    const handleStart = () => {
        setIsRunning(false);
        setCountdown(0);
        setStageIndex(0);
        setDuration(0);
        setShowFairWarning(false);
    };

    useEffect(() => {
        if (!isConnected || !isAuthenticated) return;
        const runSequence = (data) => {
            const duration = data?.timer_duration || 10;
            setStageIndex(0);
            setCountdown(duration);
            setIsRunning(true);
            setDuration(duration);
            setShowFairWarning(true);
        };

        const handleResetWarningMessage = (data) => {
            const { error, status, message } = data || {};
            if (error === 0 && status === 200) {
                handleStart();
                toast.success(message);
            }
        };

        SocketService.on("fairWarningMessage", runSequence);
        SocketService.on("resetFairWarningMessage", handleResetWarningMessage);

        return () => {
            SocketService.off("fairWarningMessage", runSequence);
            SocketService.off(
                "resetFairWarningMessage",
                handleResetWarningMessage
            );
        };
    }, [isConnected, isAuthenticated]);

    return (
        <div className={`${showFairWarning ? "s-how" : ""} bid-summary`}>
            <div className="bid-summary-inner">
                <div className="icon">
                    <i className="fa-regular fa-alarm-clock"></i>
                </div>

                <h6>
                    Fair Warning {stages[stageIndex]}
                    <span>{countdown} Seconds countdown</span>
                </h6>
            </div>

            <button
                className="btn btn-primary btn-xs btn-full"
                // onClick={handleStart}
            >
                {
                    // isRunning
                    //     ? `Running... ${countdown}s`
                    // :
                    `${countdown}s Countdown`
                }
            </button>
        </div>
    );
}
